var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[(_vm.isMarkdown)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.md.render(_vm.cleanedText))}}):_c('span',{staticClass:"plain-text",domProps:{"innerHTML":_vm._s(_vm.plainText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }